<template>
  <div class="block-adder">
    <div class="block-adder__button">
      <ToolbarIcons typeImg="plus" @clickIcon="getItems"/>
    </div>
    <div
      :class="{
        'block-adder__items': true,
        'block-adder__items_show': showItems,
      }"
    >
      <base-btn
        v-if="text"
        white
        text="Текст"
        style="margin-right: 30px"
        @click-btn="$emit('addBlock','HyperText')"
      />
      <base-btn
        v-if="img"
        white
        text="Изображение"
        style="margin-right: 30px"
        @click-btn="$emit('addBlock','Image', true)"
      />
      <base-btn
        v-if="video"
        white
        text="Видео"
        @click-btn="$emit('addBlock','Video', true)"
      />
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'

import ToolbarIcons from '@/components/icons/ToolbarIcons.vue'
import BaseBtn from '@/components/ui/BaseBtn.vue'

export default {
  name: 'BlockAdder',
  components: {
    ToolbarIcons,
    BaseBtn
  },
  props: {
    img: {
      type: Boolean,
      default: false
    },
    text: {
      type: Boolean,
      default: false
    },
    video: {
      type: Boolean,
      default: false
    }
  },
  setup () {
    const showItems = ref(false)

    const getItems = () => {
      showItems.value = !showItems.value
    }

    return {
      showItems,
      getItems
    }
  }
}
</script>

<style lang="scss" scoped>
.block-adder {
  display: flex;
  padding: 10px 0;

  &__button {
    margin-right: 30px;
    background-color: #fff;
    z-index: 2;
  }

  &__items {
    transform: translateX(-500px);
    opacity: 0;
    transition: ease-in 0.5s;
    z-index: 1;

    &_show {
      opacity: 1;
      transform: translateX(0);
      transition: ease-out 0.5s;
    }
  }
}

</style>
